/**
 * Document-related constants
 */

export const DOCUMENT_CONSTANTS = {
    CT_PREFIX: 'CT',
    DEFAULT_DOCUMENT_TITLE: 'Document',
    BOX_ROUTE_PREFIX: '/box/',
    LOADING_TEXT: '문서를 불러오는 중...',

    // Date formatting options
    DATE_FORMAT_LOCALE: 'ko-KR',
    DATE_FORMAT_OPTIONS: {
        year: 'numeric' as const,
        month: 'short' as const,
        day: 'numeric' as const,
        hour: '2-digit' as const,
        minute: '2-digit' as const,
    },

    // UI Constants
    MODAL_MAX_WIDTH: 'max-w-4xl',
    MODAL_MIN_WIDTH: 'min-w-[800px]',
    MODAL_MAX_HEIGHT: 'max-h-[80vh]',
    MODAL_Z_INDEX: 'z-[9999]',
} as const;
